import { jsxs as n, jsx as o } from "react/jsx-runtime";
import { Dropdown as t } from "../../../Dropdown/index.js";
import { CommentOptionsIcon as l, CustomDropdownList as s } from "./style.js";
import { Ellipsis as p } from "@pelando/fontawesome/icons";
import { useTranslation as c } from "../../../../hooks/useTranslation/index.js";
import { DropdownListSide as d } from "../../../Dropdown/components/DropdownList/index.js";
function w({
  moreOptions: i,
  dropdownListSide: m = d.LEFT,
  className: e
}) {
  const { t: r } = c("common");
  return i ? /* @__PURE__ */ n(t.Root, { className: e, children: [
    /* @__PURE__ */ o(t.TriggerButton, { children: /* @__PURE__ */ o(
      l,
      {
        icon: p,
        "aria-label": r("comment-options-icon-label")
      }
    ) }),
    /* @__PURE__ */ o(t.Overlay, {}),
    /* @__PURE__ */ n(s, { side: m, children: [
      /* @__PURE__ */ o(t.ListTitle, { children: r("comment-options-title") }),
      i
    ] })
  ] }) : null;
}
export {
  w as CommentOptions
};
